import { render } from "./GameGrid.vue?vue&type=template&id=6bf427ab&scoped=true&ts=true"
import script from "./GameGrid.vue?vue&type=script&lang=ts"
export * from "./GameGrid.vue?vue&type=script&lang=ts"

import "./GameGrid.vue?vue&type=style&index=0&id=6bf427ab&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf427ab"]])

export default __exports__